import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { UserBlockAction, UserBlockState } from "./types"
import { IUser } from "@/shared/api/users"

const initialState: UserBlockState = {
    isConfirmModalOpen: false,
    currentUser: null,
    action: 'block',
    onSuccess: null
}

interface OpenConfirmBlockModal {
    user: IUser
    action: UserBlockAction
    onSuccess?: () => void
}

const userBlockSlice = createSlice({
    name: 'userBlock',
    initialState,
    reducers: {
        openConfirmBlockModal: (state, action: PayloadAction<OpenConfirmBlockModal>) => {
            state.isConfirmModalOpen = true
            state.currentUser = action.payload.user
            state.action = action.payload.action
            state.onSuccess = action.payload.onSuccess ?? null
        },
        closeConfirmBlockModal: (state) => {
            state.isConfirmModalOpen = false
            state.currentUser = null
            state.onSuccess = null
        },
    }
})

export default userBlockSlice.reducer
export const { openConfirmBlockModal, closeConfirmBlockModal } = userBlockSlice.actions
